module.exports = __webpack_public_path__ + "static/media/audits_med.443bced2.jpg";